export enum ActivityIndicatorStatus {
	NotSelected = 0,
	Yes = 1,
	No = 2,
	NotProvided = 3,
}

export function isIndicatorStatusSelected(status: ActivityIndicatorStatus | undefined): boolean {
	return status !== undefined && status !== ActivityIndicatorStatus.NotSelected;
}

export type ActivityIndicatorTriStateValue = 'yes' | 'no' | 'notProvided' | null;

export function statusToTriState(status: ActivityIndicatorStatus): ActivityIndicatorTriStateValue {
	switch (status) {
		case ActivityIndicatorStatus.Yes:
			return 'yes';
		case ActivityIndicatorStatus.No:
			return 'no';
		case ActivityIndicatorStatus.NotProvided:
			return 'notProvided';
		default:
			return null;
	}
}

export function triStateToStatus(value: ActivityIndicatorTriStateValue): ActivityIndicatorStatus {
	switch (value) {
		case 'yes':
			return ActivityIndicatorStatus.Yes;
		case 'no':
			return ActivityIndicatorStatus.No;
		case 'notProvided':
			return ActivityIndicatorStatus.NotProvided;
		default:
			return ActivityIndicatorStatus.NotSelected;
	}
}
